module.exports = __webpack_public_path__ + "static/media/PenButton.9a97d44f.svg";